import { useState } from 'react';

export default function FAQSection() {
  const faqs = [
    {
      q: 'Что входит в тренинг по работе с клиентами?',
      a: 'Программа включает: психологию клиента, активное слушание, правильные вопросы, эмпатию, аргументацию, работу с ожиданиями, работу с жалобами и возражениями, конфликтные ситуации, управление эмоциями, сервис после продажи, удержание клиента, повторные продажи, коммуникацию в переписке и по телефону, очные встречи и стандарты общения. 80% времени — практика на реальных кейсах компании.',
    },
    {
      q: 'Для кого подходит тренинг?',
      a: 'Для отделов продаж, клиентского сервиса, служб поддержки, call-центров, интернет-магазинов. Подходит для B2B и B2C-компаний: производство, услуги, медицина, образование, недвижимость, банки, страхование, логистика, IT, SaaS и других отраслей.',
    },
    {
      q: 'Можно ли адаптировать программу под нашу специфику?',
      a: 'Да, каждая программа разрабатывается индивидуально после диагностики. Мы изучаем ваш продукт, рынок, категории клиентов, текущий уровень сотрудников и типовые ситуации. Ни одной шаблонной программы — только то, что работает в вашей нише с вашими клиентами.',
    },
    {
      q: 'Сколько длится обучение?',
      a: 'Форматы варьируются: интенсивный тренинг — 1–2 полных дня, модульная программа — от 2 недель до 3 месяцев, комплексная программа с сопровождением — 3–6 месяцев. Точная продолжительность определяется после диагностики и постановки бизнес-целей.',
    },
    {
      q: 'Есть ли онлайн-формат?',
      a: 'Да, тренинг полностью доступен онлайн: живые сессии с отработкой диалогов и кейсов через видеосвязь, ролевые упражнения, разбор реальных записей коммуникаций. Онлайн-формат полностью сохраняет практическую направленность и эффективность очного обучения.',
    },
    {
      q: 'Можно ли обучить сервис и продажи одновременно?',
      a: 'Да, наш подход как раз соединяет продажи, коммуникацию, сервис и долгосрочные отношения. Мы обучаем сотрудников не просто «хорошо общаться», а выстраивать доверие, выявлять потребности, предлагать ценность и сопровождать клиента — что напрямую влияет на продажи, повторные обращения и LTV.',
    },
    {
      q: 'Работаете ли вы с B2B-компаниями?',
      a: 'Да. В B2B качество коммуникации критически важно: длинный цикл сделки, несколько ЛПР, высокие риски. Обучаем системной работе с клиентами: от выявления потребностей до стратегического партнёрства. Учитываем специфику закупочных процедур, тендеров и многоуровневых согласований.',
    },
    {
      q: 'Работаете ли вы с B2C-компаниями?',
      a: 'Да. В B2C работаем над качеством обслуживания, ростом лояльности и NPS, работой с негативом и отзывами, ростом среднего чека через качественную коммуникацию. Обучаем превращать разовую покупку в долгосрочные отношения с брендом.',
    },
    {
      q: 'Есть ли сопровождение после тренинга?',
      a: 'Да, посттренинговое сопровождение — обязательный элемент нашей методологии. Мы разбираем реальные коммуникации участников, поддерживаем в чате, помогаем внедрять стандарты. Без сопровождения эффективность любого тренинга падает на 70–80% уже через месяц.',
    },
    {
      q: 'Как измерить эффективность обучения?',
      a: 'Фиксируем исходные показатели до тренинга и отслеживаем динамику: NPS, удовлетворённость клиентов, количество жалоб и претензий, повторные обращения, средний чек, конверсия. Контрольные замеры проводим через 1 и 3 месяца после обучения.',
    },
    {
      q: 'Можно ли использовать реальные кейсы компании?',
      a: 'Это основа нашей методологии. Мы разбираем реальные ситуации участников: звонки, переписки, жалобы, конфликтные кейсы. Участники видят свои реальные зоны роста и отрабатывают новые навыки на знакомом материале. Это в десятки раз эффективнее абстрактных примеров из учебников.',
    },
    {
      q: 'Что получают руководители после обучения?',
      a: 'Руководители получают: единые стандарты общения с клиентами, регламенты работы с жалобами и претензиями, скрипты для типовых ситуаций, систему контроля качества коммуникации и измеримые метрики роста. А главное — команду, которая самостоятельно и профессионально работает с клиентами, повышая лояльность и прибыль бизнеса.',
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-20 md:py-28 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-question-answer-line"></i>
            FAQ
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ответы на самые частые вопросы о тренинге по работе с клиентами.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full text-left px-5 md:px-6 py-4 flex items-center justify-between gap-4 cursor-pointer group hover:bg-teal-50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-gray-900">{faq.q}</span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === i ? 'bg-teal-600 text-white' : 'bg-gray-200 text-gray-500 group-hover:bg-teal-100 group-hover:text-teal-600'}`}>
                  <i className={`text-sm transition-transform ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-out overflow-hidden ${openIndex === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="px-5 md:px-6 pb-5 text-sm text-gray-600 leading-relaxed">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}